module.exports = __webpack_public_path__ + "img/tutorial-more-active.1d7cc434.png";